import React from "react";
import PropTypes from "prop-types";
import {textAlings} from "../../services/lib/fonts";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import NoSsr from "@material-ui/core/NoSsr";
import FormatAlignLeftIcon from "@material-ui/icons/FormatAlignLeft";
import FormatAlignCenterIcon from "@material-ui/icons/FormatAlignCenter";
import FormatAlignRightIcon from "@material-ui/icons/FormatAlignRight";
import FormatAlignJustifyIcon from "@material-ui/icons/FormatAlignJustify";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

class TextAlign extends React.Component {
  static propTypes = {
    current: PropTypes.string,
    handleChange: PropTypes.func
  };
  getIconForTextAlign(style) {
    switch (style) {
      case `left`:
        return <FormatAlignLeftIcon />;
      case `center`:
        return <FormatAlignCenterIcon />;
      case `right`:
        return <FormatAlignRightIcon />;
      case `justify`:
        return <FormatAlignJustifyIcon />;
    }
    return void 0;
  }
  state = {
    anchorEl: null
  };
  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };
  handleClose = () => {
    this.setState({anchorEl: null});
  };
  render() {
    const {current, handleChange} = this.props;
    const {anchorEl} = this.state;
    return (
      <div className="text-align">
        <NoSsr>
          <Tooltip title="Выравнивание">
            <IconButton
              aria-owns={anchorEl ? `text-align-menu` : void 0}
              aria-haspopup="true"
              onClick={this.handleClick}
            >
              {this.getIconForTextAlign(current)}
              <ArrowDropDownIcon />
            </IconButton>
          </Tooltip>
          <Menu
            id="text-align-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            {textAlings.map(({value, tooltip}) => {
              const selected = current === value;
              return (
                <MenuItem
                  key={value}
                  onClick={() => {
                    handleChange(`textAlign`, value)();
                    this.handleClose();
                  }}
                  selected={selected}
                >
                  {this.getIconForTextAlign(value)}
                  {tooltip}
                </MenuItem>
              );
            })}
          </Menu>
        </NoSsr>
      </div>
    );
  }
}

export default TextAlign;
